import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';

import { Typography } from '@cfa/react-components';

import Constants from '@/constants';

import { userPrefsAtom } from '@/atoms/userPrefs';
import { TranslationKey } from '@/i18n';

const NavCountryLabel: React.FC<{ isMobile?: boolean }> = ({ isMobile }) => {
  const { t } = useTranslation();
  const userPrefs = useAtomValue(userPrefsAtom);

  const SUPPORTED_COUNTRY_LABELS = [
    Constants.SUPPORTED_COUNTRIES.CA.id,
    Constants.SUPPORTED_COUNTRIES.PR.id,
    Constants.SUPPORTED_COUNTRIES.GB.id,
    Constants.SUPPORTED_COUNTRIES.SG.id,
  ];

  if (
    !userPrefs.country.id ||
    !SUPPORTED_COUNTRY_LABELS.includes(userPrefs.country.id)
  ) {
    return null;
  }

  const countryLabel = t(
    `Countries.iconLabel.${userPrefs.country.id}` as TranslationKey,
  );

  return (
    <Typography
      fontWeight="bold"
      variant="overline1"
      className={isMobile ? 'pl-3' : ''}
    >
      {countryLabel}
    </Typography>
  );
};

export default NavCountryLabel;
